import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { SaveEventArgs, EditSettingsModel, SortSettingsModel, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  @Output() NotificationCountChanged = new EventEmitter<void>();
  @ViewChild('navTemplate', { static: true }) navTemplate: any;
  @ViewChild('notificationGrid') public notificationGrid!:GridComponent;
  title = "Notifications";
  data!: DataManager;
  query!: Query;
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  editSettings!: EditSettingsModel;
  sortSettings!: SortSettingsModel;
  toolbar!: string[];
  columns!: object[];
  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  public formData!: UntypedFormGroup;
  currentUser: any

  constructor(private http: HttpClient, private authenticationService: AuthenticationService, private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.sortSettings = { columns: [{ field: 'CreatedOn', direction: 'Descending' }] };
    this.currentUser = this.authenticationService.currentUserValue;
    this.columns = [
      { field: 'CreatedOn', headerText: '', visible: false },
      { field: 'Id', headerText: 'Message', isPrimaryKey: true, template: this.navTemplate }
    ]
    this.data = new DataManager({
      url: this.baseUrl + "Notifications",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });

    this.query = new Query().expand('To').where('IsRead', 'equal', false);
  }
  onRowSelected(event: any): void {
    const Id = event.data.Id;
    const url = this.baseUrl + "Notifications(" + Id + ")";
    const httpOptions = {
      headers: { 'Authorization': 'Bearer ' + this.currentUser.token }
    }
    const patchBody = {
      Id: Id,
      IsRead: true
    }
    this.http.patch(url, patchBody, httpOptions).subscribe({
      next: response => {
        //this.data.executeQuery(this.query);
        this.notificationGrid.refresh();
        this.NotificationCountChanged.emit();
        //this.scopeData.Phase = status === "s" ? "Submitted" : (status === "c" ? "Closed" : "Open");
      },
      error: err => {
        console.log(err);
      }
    })
  }


}
